export const TIME_ZONES = {
	'UTC-12:00': -12,
	'UTC-11:00': -11,
	'UTC-10:00': -10,
	'UTC-09:00': -9,
	'UTC-08:00': -8,
	'UTC-07:00': -7,
	'UTC-06:00': -6,
	'UTC-05:00': -5,
	'UTC-04:00': -4,
	'UTC-03:00': -3,
	'UTC-02:00': -2,
	'UTC-01:00': -1,
	'UTC-00:00': 0,
	'UTC+01:00': 1,
	'UTC+02:00': 2,
	'UTC+03:00': 3,
	'UTC+04:00': 4,
	'UTC+05:00': 5,
	'UTC+06:00': 6,
	'UTC+07:00': 7,
	'UTC+08:00': 8,
	'UTC+09:00': 9,
	'UTC+10:00': 10,
	'UTC+11:00': 11,
	'UTC+12:00': 12,
	'UTC+13:00': 13,
	'UTC+14:00': 14,
};
